package pages.deliveries

import ics.materialUI.components.classes.ContentFieldMapping

object DeliveryDetailedPageFieldMappings {
    val orderInformationCardHeaders: Array<String> = arrayOf(
        "orderNumber",
        "reference",
        "treatment",
        "description",
        "receiver",
        "email",
        "receivedDetail",
        "expectedDetail",
        "weekNumber",
        "expectedDate",
        "processingDate"
    )

    val statusInformationCardHeaders: Array<String> = arrayOf(
        "statusDescription",
        "timeStatus",
        "totalReceived",
        "totalExpected"
    )

    val fieldMapping: Array<ContentFieldMapping> = arrayOf(
        ContentFieldMapping(
            "recordId",
            "Record Id"
        ),
        ContentFieldMapping(
            "owner",
            "Owner"
        ),
        ContentFieldMapping(
            "orderNumber",
            "Order number"
        ),
        ContentFieldMapping(
            "weekNumber",
            "Week number"
        ),
        ContentFieldMapping(
            "treatment",
            "Treatment"
        ),
        ContentFieldMapping(
            "description",
            "Description"
        ),
        ContentFieldMapping(
            "email",
            "Email"
        ),
        ContentFieldMapping(
            "receivedDetail",
            "Received detail"
        ),
        ContentFieldMapping(
            "receiver",
            "Receiver"
        ),
        ContentFieldMapping(
            "reference",
            "Reference"
        ),
        ContentFieldMapping(
            "statusDescription",
            "Status"
        ),
        ContentFieldMapping(
            "timeStatus",
            "Time status"
        ),
        ContentFieldMapping(
            "totalExpected",
            "Total expected"
        ),
        ContentFieldMapping(
            "totalReceived",
            "Total received"
        ),
        ContentFieldMapping(
            "expectedDetail",
            "Expected detail"
        ),
        ContentFieldMapping(
            "expectedDate",
            "Expected date"
        ),
        ContentFieldMapping(
            "processingDate",
            "Processing date"
        )
    )
}